/* flow */
export type FundData = Array<[string, number]>

type Fund = {
  id: string,
  name: string,
  category: string,
  category_short: string,
  currency: string,
  manager: string,
  manager_short: string,
  fund_code: string,
  risk_level: number,
  uri: string,
  pricing: {
    valuation: number,
    D: number,
    M: number,
    Q: number,
    HY: number,
    Y: number,
    Y3: number,
    Y5: number,
    YTD: number,
    MAX: number
  },
  date: string,
  sfdr_level: number
}

export type FundsBack = Array<Fund>

const REQUEST_ATTEMPTS = 3

const getData = (url: string, leftAttempts: number = 1) =>
  fetch(url)
    .then((resp: Response) => {
      if (resp.ok) {
        return resp.json()
      } else {
        if (leftAttempts <= 1) {
          throw new Error(resp.statusText)
        } else {
          return getData(url, leftAttempts - 1)
        }
      }
    })

export const getFunds = async (url: string, callback: (funds: Funds) => void) => {
  try {
    const data: FundsBack = await getData(url, REQUEST_ATTEMPTS)
    callback(data)
  } catch (err) {
    console.error(err)
  }
}

export const getFundsData = async (url: string, ids: Array<string>, callback: (Array<FundData>) => void, onError: () => void) => {
  try {
    const data: Array<FundData> = await Promise.all(ids.map(id => getData(`${url}${id}`, REQUEST_ATTEMPTS)))
    callback(data)
  } catch (err) {
    console.error(err)
    onError()
  }
}



// WEBPACK FOOTER //
// ./src/server/index.js